import * as React from "react"

export const Tag = ({ tagname, onClick, active }) => {
  return (
    <button className={`tag ${active && "active"}`} onClick={onClick}>
      {" "}
      {tagname}{" "}
    </button>
  )
}
